module.exports = __webpack_public_path__ + "img/model_02.77e8d5b9.png";